module.exports = __webpack_public_path__ + "img/hand-house.84949190.svg";